<template>
  <div class="content flex">
    <img src="../../../../static/img/diy/001.png" @mouseenter="showMenuClose">
    <div class="content-header">国家科技传播中心智慧运维平台</div>
    <div class="content-left">
      <div class="grap-box">
        <div class="grap-box-title">温度曲线</div>
        <div class="grap-box-main">
          <div ref="pieOne" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
      <div class="grap-box">
        <div class="grap-box-title">能耗柱状图</div>
        <div class="grap-box-main">
          <div ref="pieTwo" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
      <div class="grap-box">
        <div class="grap-box-title">近两月能耗对比</div>
        <div class="grap-box-main">
          <div ref="pieThree" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
    </div>
    <div class="content-right">
      <div class="grap-box">
        <div class="grap-box-title">能耗占比饼状图</div>
        <div class="grap-box-main">
          <div ref="rightOne" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
      <div class="grap-box">
        <div class="grap-box-title">环境占比雷达图</div>
        <div class="grap-box-main">
          <div ref="rightTwo" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
      <div class="grap-box">
        <div class="grap-box-title">日历</div>
        <div class="grap-box-main" style="height: 100%;">
          <div ref="rightThree" style="width: 100%;height: 100%;"></div>
        </div>
      </div>
    </div>

    <div class="content-ul">
      <transition name="bounceone" type="transition">
        <div class="mask" v-if="menushow">
          <div class="div2">
            <button class="bui-btn" @click="cadShowBox = true">4FJ</button>
            <button class="bui-btn" @click="cadShowBox = true">4F</button>
            <button class="bui-btn" @click="cadShowBox = true">3FJ</button>
            <button class="bui-btn" @click="cadShowBox = true">3F</button>
            <button class="bui-btn" @click="cadShowBox = true">2FJ</button>
            <button class="bui-btn" @click="cadShowBox = true">2F</button>
            <button class="bui-btn" @click="cadShowBox = true">1FJ</button>
            <button class="bui-btn" style="border-bottom: 1px ridge #149CEA;" @click="cadShowBox = true">1F</button>
          </div>
        </div>
      </transition>
    </div>

    <div class="building-box" @mouseenter="showMenu"></div>
    <div class="content-bottom"></div>
    <transition name="bounce" type="transition">
      <div class='cad-show-box' v-if="cadShowBox">
        <cadshow></cadshow>
      </div>
    </transition>

  </div>
</template>

<script>
import echarts from 'echarts';
import service from '../../../service/leftService.js'
import cadshow from './cadshow.vue'


export default {
  name: '',
  props: [''],
  data() {
    return {
      cadShowBox: false,
      vedioSrc: '',
      color: ['#BCD7FB', '#2F8DF4', '#2EC6D0'],
      model: {
        yCates: ['Saturday', 'Friday', 'Thursday',
          'Wednesday', 'Tuesday', 'Monday',
          'Sunday'],
        xCates: ['1', '2', '3', '4', '5'],
        data: [
          // [yCateIndex, xCateIndex, value]
          [0, 0, 5], [0, 1, 7], [0, 2, 3], [0, 3, 5], [0, 4, 2],
          [1, 0, 1], [1, 1, 2], [1, 2, 4], [1, 3, 8], [1, 4, 2],
          [2, 0, 2], [2, 1, 3], [2, 2, 8], [2, 3, 6], [2, 4, 7],
          [3, 0, 3], [3, 1, 7], [3, 2, 5], [3, 3, 1], [3, 4, 6],
          [4, 0, 3], [4, 1, 2], [4, 2, 7], [4, 3, 8], [4, 4, 9],
          [5, 0, 2], [5, 1, 2], [5, 2, 3], [5, 3, 4], [5, 4, 7],
          [6, 0, 6], [6, 1, 5], [6, 2, 3], [6, 3, 1], [6, 4, 2]
        ]
      },
      menushow: false,
      maxNum: 14,
      chartData: [
        {
          "value": [
            "2019-10-01",
            0
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-02",
            0
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-03",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-04",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-05",
            2
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-06",
            2
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-07",
            4
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-08",
            3
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-09",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-10",
            2
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-11",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-12",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-13",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-14",
            8
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-15",
            14
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-16",
            2
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-17",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-18",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-19",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-20",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-21",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-22",
            3
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-23",
            2
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-24",
            1
          ],
          "itemStyle": {
          },
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-25",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-26",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-27",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-28",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-29",
            1
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-30",
            0
          ],
          "itemStyle": {},
          "symbol": "rect"
        },
        {
          "value": [
            "2019-10-31",
            0
          ],
          "itemStyle": {},
          "symbol": "rect"
        }
      ],
      thisDate: '2019-10-24',
      thisMonth: '2019-10'
    };
  },

  components: {
    cadshow
  },

  computed: {},

  beforeMount() { },

  mounted() {
    this.$nextTick(function () {
      this.initializeEcharts();
    });
    this.getTok()
  },
  provide() {

  },
  methods: {
    initializeEcharts() {
      let _this = this
      let pieOne = echarts.init(this.$refs.pieOne);
      pieOne.setOption(
        {
          backgroundColor: '',
          tooltip: {
            trigger: 'axis', //触发类型。[ default: 'item' ] :数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用;'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
            axisPointer: {
              lineStyle: {
                color: '#57617B'
              }
            }
          },
          legend: {
            icon: 'rect', //设置图例的图形形状，circle为圆，rect为矩形
            itemWidth: 14, //图例标记的图形宽度[ default: 25 ] 
            itemHeight: 5, //图例标记的图形高度。[ default: 14 ] 
            itemGap: 13, //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。[ default: 10 ] 
            data: ['移动', '电信', '联通'],
            right: '4%', //图例组件离容器右侧的距离
            textStyle: {
              fontSize: 12,
              color: '#b9b9b9'
            }
          },
          grid: {
            left: '3%', //grid 组件离容器左侧的距离。
            right: '4%', //grid 组件离容器右侧的距离。
            bottom: '3%', //grid 组件离容器下侧的距离。
            containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ] 
          },
          xAxis: [{
            type: 'category',
            boundaryGap: false, //坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样
            axisLine: {
              lineStyle: {
                color: '#b9b9b9' //坐标轴线线的颜色。
              }
            },
            data: ['20231101', '20231102', '20231103', '20231104', '20231105', '20231106',
              '20231107', '20231108', '20231109', '20231110', '20231111', '20231112',
              '20231113', '20231114', '20231115', '20231116', '20231117', '20231118',
              '20231119', '20231120', '20231121', '20231122', '20231123', '20231124',
              '20231125', '20231126', '20231127', '20231128', '20231129', '20231130',
              '20231201']
          }],
          yAxis: [{
            type: 'value', //坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
            name: '回风温湿度', //坐标轴名称。
            axisTick: {
              show: false //是否显示坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                color: '#b9b9b9' //坐标轴线线的颜色
              }
            },
            axisLabel: {
              margin: 10, //刻度标签与轴线之间的距离
              textStyle: {
                fontSize: 14 //文字的字体大小
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: '#57617B' //分隔线颜色设置
              }
            }
          }],
          series: [{
            name: '温度',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0, 136, 212, 0.3)'
                }, {
                  offset: 0.8,
                  color: 'rgba(0, 136, 212, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: 'rgb(0,136,212)',
                borderColor: 'rgba(0,136,212,0.2)',
                borderWidth: 12

              }
            },
            data: [32, 25, 34, 26, 34, 32, 29, 27, 36, 32, 34, 28, 22,
              32, 30, 18, 15, 29, 18, 28, 32, 29, 18, 22, 35, 25,
              18, 18, 28, 32, 31]
          },
          {
            name: '湿度',
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1
              }
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(0, 136, 212, 0.3)'
                }, {
                  offset: 0.8,
                  color: 'rgba(0, 136, 212, 0)'
                }], false),
                shadowColor: '#889BD8',
                shadowBlur: 10
              }
            },
            itemStyle: {
              normal: {
                color: '#889BD8',
                borderColor: '#889BD8',
                borderWidth: 12

              }
            },
            data: [30, 25, 60, 80, 70, 25, 65, 48, 28, 34, 42, 95, 85,
              67, 20, 94, 19, 56, 90, 16, 72, 16, 2, 72, 12, 59,
              33, 76, 74, 29, 73]
          },]
        }
      )
      window.addEventListener('resize', () => {
        pieOne.resize()
      })

      let pieTwo = echarts.init(this.$refs.pieTwo);
      pieTwo.setOption(
        {
          grid: {
            left: '5%',
            right: '5%',
            bottom: '0%',
            top: '5%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'none'
            },

          },
          xAxis: {
            show: false,
            type: 'value'
          },
          yAxis: [{
            type: 'category',
            inverse: true,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff'
              },
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            data: ['1F', '1FJ', '2F', '2FJ', '3F', '3FJ', '4F', '4FJ']
          }, {
            type: 'category',
            inverse: true,
            axisTick: 'none',
            axisLine: 'none',
            show: true,
            axisLabel: {
              textStyle: {
                color: '#ffffff',
                fontSize: '12'
              },
              formatter: function (value) {

                return value.toLocaleString() + "kW·h";

              },
            },
            data: [52, 80, 70, 58, 90, 75, 82, 92]
          }],
          series: [{
            name: '能耗',
            type: 'bar',
            zlevel: 1,
            itemStyle: {
              normal: {
                barBorderRadius: 10,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                  offset: 0,
                  color: 'rgb(57,89,255,1)'
                }, {
                  offset: 1,
                  color: 'rgb(46,200,207,1)'
                }]),
              },
            },
            barWidth: 10,
            data: [52, 80, 70, 58, 90, 75, 82, 92]
          },
          {
            name: '',
            type: 'bar',
            barWidth: 10,
            barGap: '-100%',
            data: [100, 100, 100, 100, 100, 100, 100, 100],
            itemStyle: {
              normal: {
                color: 'rgba(24,31,68,1)',
                barBorderRadius: 20,
              }
            },
          },
          ]
        }
      )
      window.addEventListener('resize', () => {
        pieTwo.resize()
      })
      let pieThree = echarts.init(this.$refs.pieThree);
      pieThree.setOption(
        {
          backgroundColor: '',
          legend: {
            top: "20",
            x: "center",
            textStyle: {
              fontSize: 16,
              color: "rgba(101, 213, 255, 1)"
            },
            icon:
              "path://M512 881.777778 512 881.777778C716.222629 881.777778 881.777778 716.222629 881.777778 512 881.777778 307.777371 716.222629 142.222222 512 142.222222 307.777373 142.222222 142.222222 307.777371 142.222222 512 142.222222 716.222629 307.777373 881.777778 512 881.777778L512 881.777778ZM512 1024 512 1024C229.230208 1024 0 794.769789 0 512 0 229.230211 229.230208 0 512 0 794.769789 0 1024 229.230211 1024 512 1024 794.769789 794.769789 1024 512 1024L512 1024Z",
            itemWidth: 8, // 设置宽度
            itemHeight: 8, // 设置高度、
            itemGap: 12 // 设置间距
          },
          tooltip: {
            show: true,
            trigger: "axis", //axis , item
            backgroundColor: "RGBA(0, 49, 85, 1)",
            borderColor: "rgba(0, 151, 251, 1)",
            borderWidth: 1,
            borderRadius: 0,
            textStyle: {
              color: "#BCE9FC",
              fontSize: 16,
              align: "left"
            }
          },
          grid: {
            right: "5%",
            top: "20%",
            left: "5%",
            bottom: "5%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: true,
            data: ["1F", "1FJ", '2F', '2FJ', '3F', '3FJ', '4F', '4FJ'],
            axisLabel: {
              //坐标轴刻度标签的相关设置。
              interval: 0, //设置为 1，表示『隔一个标签显示一个标签』
              //	margin:15,
              textStyle: {
                color: "#65D5FF",
                fontStyle: "normal",
                fontSize: 16
              }
            },
            axisTick: {
              //坐标轴刻度相关设置。
              show: false
            },
            axisLine: {
              //坐标轴轴线相关设置
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)"
              }
            },
            splitLine: {
              //坐标轴在 grid 区域中的分隔线。
              show: false,
              lineStyle: {
                color: "rgba(77, 128, 254, 0.2)"
              }
            }
          },
          yAxis: [
            {
              type: "value",
              splitNumber: 3,
              axisLabel: {
                textStyle: {
                  color: "#65D5FF",
                  fontStyle: "normal",
                  fontSize: 16
                }
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              splitLine: {
                show: false,
                lineStyle: {
                  color: "rgba(77, 128, 254, 0.2)"
                }
              }
            }
          ],
          series: [
            {
              name: '11月',
              type: "pictorialBar",
              barWidth: "60%",
              stack: "总量",
              label: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(0, 151, 251, 1)" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(0, 34, 66, 0.2)" // 100% 处的颜色
                      }
                    ],
                    globalCoord: false // 缺省为 false
                  } //渐变颜色
                }
              },
              symbol:
                "path://M12.000,-0.000 C12.000,-0.000 16.074,60.121 22.731,60.121 C26.173,60.121 -3.234,60.121 0.511,60.121 C7.072,60.121 12.000,-0.000 12.000,-0.000 Z",

              data: [23, 84, 101, 74, 87, 105, 95, 86]
            }, {
              name: '12月',
              type: "pictorialBar",
              barWidth: "60%",
              stack: "总量",
              label: {
                normal: {
                  show: false
                }
              },
              itemStyle: {
                normal: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(48, 236, 166, 1)" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(0, 34, 66, 0.2)" // 100% 处的颜色
                      }
                    ],
                    globalCoord: false // 缺省为 false
                  } //渐变颜色
                }
              },
              symbol:
                "path://M12.000,-0.000 C12.000,-0.000 16.074,60.121 22.731,60.121 C26.173,60.121 -3.234,60.121 0.511,60.121 C7.072,60.121 12.000,-0.000 12.000,-0.000 Z",
              data: [13, 54, 71, 24, 57, 65, 35, 54]
            }],
        }
      )
      window.addEventListener('resize', () => {
        pieThree.resize()
      })
      let rightOne = echarts.init(this.$refs.rightOne);
      rightOne.setOption(
        {
          color: this.color,
          title: {
            text: '',
            left: 'center',
            top: '50%',
            textStyle: {
              fontSize: 10,
              color: '#fff',
              fontWeight: 'normal'
            }
          },
          tooltip: {
            trigger: 'item'
          },
          series: [{
            type: 'pie',
            roseType: 'radius',
            radius: ['30%', '60%'],
            data: [{
              value: 220,
              name: '社会组织'
            }, {
              value: 120,
              name: '事业单位'
            },
            {
              value: 189,
              name: '工商企业登记注册'
            }
            ],
            label: {
              normal: {
                formatter: '{font|{c}}\n{hr|}\n{font|{d}%}',
                rich: {
                  font: {
                    fontSize: 10,
                    padding: [5, 0],
                    color: '#fff'
                  },
                  hr: {
                    height: 0,
                    borderWidth: 1,
                    width: '100%',
                    borderColor: '#fff'
                  }
                }
              },
            },
            labelLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0,0,0,0.5)'
              }
            }
          }]
        }
      )
      window.addEventListener('resize', () => {
        rightOne.resize()
      })
      let rightTwo = echarts.init(this.$refs.rightTwo);
      rightTwo.setOption(
        {
          tooltip: {},

          radar: {
            radius: "70%", //大小
            nameGap: 1, // 图中工艺等字距离图的距离
            center: ["50%", "50%"], // 图的位置
            name: {
              textStyle: {
                color: "rgba(101, 213, 255, 1)",
                fontSize: 16
              },
              formatter: function (name) {
                return name;
              }
            },
            indicator: [
              { "name": 'CO2', "max": "100" },
              { "name": 'VOC', "max": "100" },
              { "name": '温度', "max": "100" },
              { "name": '湿度', "max": "100" },
              { "name": '气压', "max": "100" },
              { "name": 'PM2.5', "max": "100" },

            ],
            axisLine: {
              lineStyle: {

                color: "rgba(153, 209, 246, 0.2)"
              }
            },
            splitArea: {
              show: false,
              areaStyle: {
                color: "rgba(255,0,0,0)" // 图表背景的颜色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                width: 1,
                color: "rgba(153, 209, 246, 0.2)" // 设置网格的颜色
              }
            }
          },

          series: [
            {
              name: "报警类型分析",
              type: "radar",
              symbol: "angle",
              itemStyle: {
                normal: {
                  areaStyle: { type: "default" }
                }
              },
              data: [
                {
                  symbol: "circle",
                  symbolSize: 5,
                  value: [70, 42, 63, 84, 75, 34],
                  areaStyle: { color: "rgba(64, 205, 241, 0.2)" },
                  itemStyle: {
                    normal: {
                      borderWidth: 1,
                      color: "RGBA(0, 34, 66, 1)",
                      borderColor: "rgba(146, 225, 255, 1)"
                    }
                  },
                  lineStyle: {
                    color: "rgba(146, 225, 255, 1)",
                    width: 1
                  }
                }
              ]
            }
          ]
        }
      )
      window.addEventListener('resize', () => {
        rightTwo.resize()
      })

      let rightThree = echarts.init(this.$refs.rightThree);
      rightThree.setOption(
        {
          backgroundColor: '',
          calendar: {
            left: 'center',
            top: '20%',
            orient: 'vertical',
            cellSize: 45, //大小
            range: this.thisMonth, //月份
            monthLabel: {
              show: false, //隐藏左侧文字
            },
            dayLabel: {
              firstDay: 1, //开始时间 1号开始
              color: '#BCD7FB',
              nameMap: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
            },
            yearLabel: {
              show: false, //隐藏title
            },
          },
          visualMap: {
            type: 'continuous',
            min: 0,
            max: this.maxNum, //色值对比 最大值
            show: false, //隐藏工具栏
            inRange: {
              color: ['#F1FCFE', '#2D5AF1', '#2D5AF1', '#2D5AF1'],
            },
          },
          series: [
            {
              type: 'scatter',
              coordinateSystem: 'calendar',
              symbolSize(params) { //核心2 
                if (params[0] === _this.thisDate) {
                  return 20; //当前日期高亮 宽度高度设置成和单元格宽度高度一样
                } else {
                  return 1;
                }
              },
              label: {
                normal: {
                  show: true,
                  formatter: function (params) {
                    return echarts.format.formatTime('dd', params.value[0]);
                  },
                  textStyle: {
                    color: '#000',
                  },
                },
              },
              data: this.chartData,
            },
            {
              type: 'heatmap',
              coordinateSystem: 'calendar',
              data: this.chartData,
            },
          ],
        }
      )
      window.addEventListener('resize', () => {
        rightThree.resize()
      })
    },
    getTok() {
      /*  service.tokenYingshi().then(res => {
         let token = res.accessToken
         this.vedioSrc = `https://open.ys7.com/jssdk/theme.html?url=ezopen://open.ys7.com/G68365821/1.hd.live&autoplay=1&accessToken=${token}&id=ysopen`
         console.log(this.vedioSrc, '视频地址')
       }).catch(err => {
          
       }) */
    },
    // 关闭cad试图
    closeCad() {
      this.cadShowBox = false
    },
    showMenu() {
      this.menushow = true
    },
    showMenuClose() {
      this.menushow = false
    },
    filterList() {
      const defaultErrorFilter = {
        name: 'error',
        priority: "before",
        args: ['operate', 'value'],
        default: {
          operate: 'ignore',
        },
        next(value, args, context) {
          const operate = args.operate.toLowerCase()
        }
      }
    },
  },
  destroyed() {

  },
  beforeDestroy() {

  },
  watch: {

  }
}

</script>
<style lang="scss" scoped>
.bounceone-enter-from,
.bounceone-leave-to {
  opacity: 0;
}

.bounceone-enter-active,
.bounceone-leave-active {
  transition: opacity 1s ease;
}

.bounceone-enter-active {
  animation: animate 1s ease;
}

.bounceone-leave-active {
  animation: animate 1s ease reverse;
}

.bounce-enter-from,
.bounce-leave-to {
  opacity: 0;
}

.bounce-enter-active,
.bounce-leave-active {
  transition: opacity 1s ease;
}

.bounce-enter-active {
  animation: bounce 1s ease;
}

.bounce-leave-active {
  animation: bounce 1s ease reverse;
}

@keyframes bounce {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.5);
  }

  100% {
    transform: scale(1);
  }
}

.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

@keyframes animate {
  from {
    height: 0px;
    top: 100%;
  }

  to {
    height: 100%;
    top: 0px;
  }
}

.content {
  width: 100%;
  height: 100%;
  /* background-color: #3e3e3e; */
  position: relative;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  background: radial-gradient(ellipse at bottom, #1b2735 0%, #090a0f 100%);
  /*  background-image: url('../../../../static/img/diy/001.png'); */
  background-size: 100% 100%;

  .content-header {
    position: absolute;
    top: 0;
    width: 100%;
    height: 6%;
    background-image: url('../../../../static/img/diy/002.png');
    background-size: 100% 100%;
    font-size: 2.8vh;
    text-align: center;
    color: #BCD7FB;
    font-family: '黑体';
    font-weight: 600;
  }

  .content-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 6%;
    background-image: url('../../../../static/img/diy/004.png');
    background-size: 100% 100%;
  }

  .content-ul {
    position: absolute;
    z-index: 10;
    top: 25%;
    left: 35%;
    width: 4rem;
    height: 19em;

    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      /* animation: animate 3s ease normal; */
      overflow: hidden;

      .div2 {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        bottom: 0;

        .bui-btn {
          width: 78px;
          position: relative;
          height: 30px;
          border-left: 1px ridge #149CEA;
          border-right: 1px ridge #149CEA;
          border-top: 1px ridge #149CEA;
          border-bottom: 1px ridge transparent;
          outline: none;
          background-color: transparent;
          color: white;
          transition: 1s;
          border-radius: 0.3em;
          font-size: 10px;
          cursor: pointer;
        }


        .bui-btn:hover::before,
        .bui-btn:hover::after {
          transform: scale(0)
        }

        .bui-btn:hover {
          box-shadow: inset 0px 0px 25px #1479EA;
        }
      }
    }
  }

  .building-box {
    position: absolute;
    z-index: 10;
    top: 35%;
    left: 40%;
    width: 7rem;
    height: 5rem;
    cursor: pointer;
    border-radius: 50%;
  }

  .content-left {
    width: 20%;
    height: 100%;
    position: absolute;
    left: 0;
    box-sizing: border-box;
    padding: 30px 0px 10px 10px;
  }

  .content-right {
    width: 20%;
    height: 100%;
    position: absolute;
    right: 0;
    padding: 30px 10px 10px 0;
  }

  .grap-box {
    width: 100%;
    height: 30%;
    margin-bottom: 10px;

    .grap-box-title {
      width: 100%;
      height: 10%;
      background-image: url('../../../../static/img/guanghuan/title_background.png');
      background-size: 100% 100%;
      padding-left: 5%;
      padding-top: 1%;
      color: #BCD7FB;

    }

    .grap-box-main {
      width: 100%;
      height: 90%;
    }
  }
}

.cad-show-box {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
}
</style>


// WEBPACK FOOTER //
// src/components/graphically/GCBIG/index.vue